import { useFormContext } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@/view/components/ui/use-toast'
import { NewPasswordFormData } from '../components/types'
import { authService } from '@/app/services/authService'

interface UseNewPasswordControllerProps {
  token: string
}

export const useNewPasswordController = ({
  token,
}: UseNewPasswordControllerProps) => {
  const methods = useFormContext<NewPasswordFormData>()
  const { toast } = useToast()
  const navigate = useNavigate()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      token,
      password,
    }: {
      token: string
      password: string
    }) => {
      return authService.newPassword({ token, password })
    },
  })

  const handleFormSubmit = async (data: NewPasswordFormData) => {
    try {
      if (!token) {
        toast({
          variant: 'destructive',
          title: 'Erro',
          description: 'Token não encontrado. Volte para a tela anterior.',
        })
        return
      }

      await mutateAsync({ token, password: data.password })

      toast({
        title: 'Senha redefinida com sucesso!',
        description: 'Você pode fazer login com sua nova senha.',
      })

      navigate('/')
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao redefinir senha',
        description: 'Tente novamente mais tarde.',
      })
    }
  }

  return {
    methods,
    isPending,
    handleFormSubmit,
  }
}
